// extracted by mini-css-extract-plugin
module.exports = {"image-block":"InstagramImage-module__image-block___FG1xC","image":"InstagramImage-module__image___3Q42v"};